var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faCheck, faCheckCircle, faCirclePlus, faMinusCircle, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useTranslation } from "react-i18next";
import Editor from "./editor";
import { Slot } from "@/utils/types/layout";
import { useLayout } from "@/hooks/layout";
import { useEffect, useState } from "react";
import { useLogger } from "@/utils/loggerService";
import copy from "fast-copy";
import { useGetFiltersQuery, useSaveFilterMutation } from "@/store/api";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { setFiltersSelected } from "@/store/filterSlice";
export default function WidgetManager(_a) {
    var _this = this;
    var widget = _a.widget;
    var logger = useLogger().logger;
    var t = useTranslation(["common"]).t;
    var layout = useLayout();
    var payload = widget.payload;
    var module = useParams().module;
    var moduleName = module || "Accounts";
    var _b = useState(), editedFilter = _b[0], setEditedFilter = _b[1];
    var _c = useState([]), appliedFilters = _c[0], setAppliedFilters = _c[1];
    var _d = useState(""), message = _d[0], setMessage = _d[1];
    var genericId = Date.now().toString(36);
    /**
     * Créer le filtre
     * @returns QueryFilter
     */
    var newFilter = function () {
        setEditedFilter(null);
        setMessage("");
        return {
            id: genericId,
            name: "",
            module: moduleName,
            filters: { operator: "", rules: [] },
        };
    };
    var applyFilter = function () { return __awaiter(_this, void 0, void 0, function () {
        var isElementExistInArray, appliedFiltersUpdated;
        return __generator(this, function (_a) {
            console.log("aplied Filter : ", appliedFilters);
            setMessage("");
            isElementExistInArray = appliedFilters.filter(function (af) { return af.id === (editedFilter === null || editedFilter === void 0 ? void 0 : editedFilter.id); }).length > 0;
            if (isElementExistInArray) {
                setMessage(String(t("app.LBL_MODIF_SAVED")));
                appliedFiltersUpdated = appliedFilters.map(function (af) {
                    return af.id === (editedFilter === null || editedFilter === void 0 ? void 0 : editedFilter.id) ? (af = editedFilter) : af;
                });
                setAppliedFilters(appliedFiltersUpdated);
            }
            else {
                setAppliedFilters(__spreadArray(__spreadArray([], (appliedFilters || []), true), [editedFilter], false));
                setEditedFilter(null);
            }
            return [2 /*return*/];
        });
    }); };
    var editAppliedFilter = function (index) {
        setMessage("");
        setEditedFilter({
            id: appliedFilters[index].id,
            name: appliedFilters[index].name,
            module: moduleName,
            filters: appliedFilters[index].filters,
        });
    };
    var removeAppliedFilter = function (index) {
        var filters = copy(appliedFilters);
        filters.splice(index, 1);
        setAppliedFilters(filters);
    };
    useEffect(function () {
        var filter = payload.new && !editedFilter ? newFilter() : editedFilter;
        setEditedFilter(filter);
    }, [payload.new, editedFilter]);
    var _e = useSaveFilterMutation(), saveFilterMutation = _e[0], _f = _e[1], saveData = _f.data, tokenAccessError = _f.error;
    var _g = useState(), listFilters = _g[0], setListFilters = _g[1];
    var _h = useGetFiltersQuery(moduleName || "Accounts"), filtersResponse = _h.data, isLoading = _h.isLoading, isError = _h.isError, isFetching = _h.isFetching;
    useEffect(function () {
        var data = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.data;
        setListFilters((data === null || data === void 0 ? void 0 : data.filters[moduleName]) || []);
        !payload.new && setAppliedFilters(data === null || data === void 0 ? void 0 : data.filters[moduleName]);
    }, [filtersResponse]);
    var dispatch = useAppDispatch();
    var filters_selected_state = useAppSelector(function (state) { return state.filter.selector_filters; });
    var saveFilter = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, updated_filters_selector_state, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, saveFilterMutation({
                            moduleName: moduleName,
                            body: !(payload === null || payload === void 0 ? void 0 : payload.new)
                                ? { filters: appliedFilters }
                                : { filters: __spreadArray(__spreadArray([], listFilters, true), [editedFilter], false) },
                        }).unwrap()];
                case 1:
                    result = _a.sent();
                    if (filters_selected_state && !(payload === null || payload === void 0 ? void 0 : payload.new)) {
                        updated_filters_selector_state = appliedFilters.filter(function (element) {
                            if (filters_selected_state.find(function (f) { return f.id === element.id; })) {
                                return element;
                            }
                        });
                        dispatch(setFiltersSelected(updated_filters_selector_state));
                    }
                    layout.removeWidgetById({
                        id: widget.id,
                        slot: [Slot.DRAWER_SOUTH],
                        type: "widget/managerFilter",
                    });
                    toast.success(t("app.LBL_FILTER_SAVED"));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    toast.error(t("app.LBL_FILTER_NOT_SAVED"));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "bg-gray-100" }, { children: [_jsx("p", __assign({ className: " text-xl border-b-[1px]" }, { children: payload.new ? t("app.LBL_EDITION_FILTER") : t("app.LBL_MANAGE_FILTER") })), _jsxs("div", __assign({ className: "grid ".concat(payload.new ? " grid-cols-1 p-5 " : "grid-cols-2 pb-5 ") }, { children: [!payload.new && (_jsxs("div", __assign({ className: "pt-3 px-5 " }, { children: [_jsxs("div", __assign({ className: "flex justify-between p-3 bg-[rgb(var(--color-blue-500))]" }, { children: [_jsx("span", __assign({ className: "text-[var(--color-white)] font-bold" }, { children: t("app.LBL_FILTER") })), _jsx("span", { children: _jsx(FontAwesomeIcon, { icon: faCirclePlus, className: "text-[rgb(var(--color-gray-600))] cursor-pointer ", onClick: function () { return setEditedFilter(newFilter()); } }) })] })), _jsx("div", __assign({ className: "h-40 border-[2px] overflow-scroll " }, { children: appliedFilters && (_jsx(_Fragment, { children: appliedFilters.map(function (af, index) { return (_jsx("div", __assign({ className: "flex justify-between p-3 bg-[rgb(var(--color-slate-200))]" }, { children: _jsxs("span", { children: [_jsx(FontAwesomeIcon, { icon: faMinusCircle, className: "text-[rgb(var(--color-gray-600))] pr-1 cursor-pointer ", onClick: function () { return removeAppliedFilter(index); } }), _jsx("span", __assign({ className: " cursor-pointer text-sm", onClick: function () {
                                                        editAppliedFilter(index);
                                                    } }, { children: af.name ? af.name : "no_name" }))] }) }), index)); }) })) }))] }))), editedFilter && (_jsxs("div", __assign({ className: "" }, { children: [editedFilter && message && message !== editedFilter.name && (_jsxs("span", __assign({ className: "text-[--color-green-700] text-sm" }, { children: [_jsx(FontAwesomeIcon, { icon: faCheckCircle, className: "pr-1 w-" }), message] }))), _jsx(Editor, { filter: editedFilter, onFilterUpdated: function (updatedFilter) {
                                    setEditedFilter(updatedFilter);
                                    logger.debug("Manager - onFilterUpdated: ", updatedFilter);
                                }, module: moduleName, inputClassName: "".concat(payload.new && "w-1/6") }), !payload.new && editedFilter.filters.rules.length > 0 && (_jsxs("button", __assign({ className: "button success text-sm", onClick: function () {
                                    applyFilter();
                                }, id: "apply-btn" }, { children: [_jsx(FontAwesomeIcon, { icon: faCheck, size: "sm", className: "pr-1" }), t("app.LBL_VALIDATE")] })))] })))] })), _jsxs("div", __assign({ className: "grid grid-cols-2 justify-items-center border-t-[1px] p-2 " }, { children: [_jsx("div", __assign({ className: "" }, { children: _jsx("button", __assign({ className: "button secondary", onClick: function () {
                                layout.removeWidgetById({
                                    id: widget.id,
                                    slot: [Slot.DRAWER_SOUTH],
                                    type: "widget/managerFilter",
                                });
                            } }, { children: t("app.LBL_CANCEL") })) })), _jsx("div", { children: _jsx("button", __assign({ onClick: function () {
                                saveFilter();
                            }, className: "button primary" }, { children: t("app.LBL_UPDATE") })) })] }))] })));
}
widgetsDictionary.register("widget/managerFilter", {
    name: "Widget manager filter",
    display: WidgetManager,
    selectable: false,
});
